module.exports = __webpack_public_path__ + "img/idigi.9a2839ee.svg";